import $http from '../http'
import axios from 'axios'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/v2'

const talent = {
  getTalents(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/TalentsMamage/TalentsPageList`,
      params
    })
  },
  getResumeClassSummaryData() {
    return $http({
      method: 'get',
      url: `${BASEURL}/TalentsMamage/Collect`
    })
  },
  addTalentResume(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/TalentsMamage/EditTalents`,
      data
    })
  },
  getResumeDetails(id) {
    return $http({
      method: 'get',
      url: `${BASEURL}/TalentsMamage/TalentsDetailList?ids=${id}`
    })
  },
  getBuyResumeDetails(tid) {
    return $http({
      method: 'get',
      url: `${BASEURL}/TalentsMamage/TalentsDetailInPlatform?id=${tid}`
    })
  },
  deleteTalentResume(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/TalentsMamage/Delete`,
      data
    })
  },
  editRemark(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/TalentsMamage/EditRemark`,
      data
    })
  },
  deleteRemark(id) {
    return $http({
      method: 'post',
      url: `${BASEURL}/TalentsMamage/DeleteRemarrk?remarkId=${id}`
    })
  },
  addAccessory(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/TalentsMamage/AddAccessory`,
      data
    })
  },
  deleteAccessory(id) {
    return $http({
      method: 'post',
      url: `${BASEURL}/TalentsMamage/DeleteAccessory?accessoryIs=${id}`
    })
  },
  // 简历解析
  cvparse(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/cv/cvparse_base64`,
      headers: {
        'user-id': 'mscsia_test',
        'user-password': 'mscsia_test',
        'Content-Type': 'application/json'
      },
      data
    })
  },
  batchSendEmail(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/TalentsMamage/SendEmail`,
      data
    })
  },
  getResumeBuyInfo(key, t) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Main/SiteConfigs/GetConfigValue?_t=${t}&key=${key}`
    })
  }
}

export default talent
